import React, { useState,useEffect } from 'react'
import styles from './ResultSuccess.module.css'
import { Check, Page } from '../components/icons'
import {PAYCELL_LOGO} from '../constants'

import PropTypes from 'prop-types'
import axios from 'axios'
import { API_BASE } from '../config/env'
import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'
import { Button, Header, Icon, Modal,Image } from 'semantic-ui-react'
import {Link} from "react-router-dom";

import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import Receipt from './receipt/Receipt';


function ResultSuccess(props) {
  ResultSuccess.prototype = {
    paymentResult: PropTypes.object
  }


  const [open, setOpen] = useState(false)
  const [receipt, setReceipt] = useState('')

  useEffect(async () => {
    setReceipt(await callGetReceipt());
  }, []);

  const showReceipt = async () => {
    const receiptResponse = await callGetReceipt()
    setReceipt(receiptResponse.data)
    setOpen(true)
  }

  const callGetReceipt = async () => {
    let requestBody = {
      transactionId: props.paymentResult.invoiceInfo.transactionId,
      channelRefNo: '',
      paymentOperation: props.paymentResult.invoiceInfo.paymentOperation
    }

    try {
      const response = await axios.post(`${API_BASE}/getReceipt`, requestBody)
      if (response.status === 200) {
        // response - object, eg { status: 200, message: 'OK' }
        return response
      }
      return false
    } catch (err) {
      console.error(err)
      return false
    }
  }

  const printReceipt = () => {
    const input = document.getElementById('divToPrint')
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL('image/png')
      const pdf = new jsPDF()
      pdf.addImage(imgData, 'JPEG', 0, 0)
      // pdf.output('dataurlnewwindow');
      pdf.save('Dekont.pdf')
    })
  }

  return (
    <div className={styles.container}>
      <div className={styles.container}>
        <Check className={styles.checkIcon} />
      </div>

      <div className={styles.container}>
        <label className={styles.label1}>Ödemeniz Tamamlandı! </label>
      </div>
      <div>
        <label className={styles.label2}>
          Toplam Tutar :
          <label className={styles.label1}> {props.paymentResult.invoiceInfo.totalAmount} TL
          </label>
        </label>
      </div>
      <div>
        <label className={styles.label2}>
          Ödeme Yöntemi :
          <label className={styles.label1}> Kredi Kartı (3D)</label>
        </label>
      </div>
      <br />
      <br />
      <div>
        <span className={styles.labelLink} onClick={showReceipt}>
          <Page className={styles.smallIcon} /> Dekont Görüntüle
        </span>
      </div>
    <br />
    <br />
    <div>
        <Link to="/"> Farklı bir fatura için tekrar dene</Link>
    </div>

      <Modal
        size='mini'
        dimmer='blurring'
        closeIcon
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      >

        <Header style={{alignItems:'center'}} >
          <Image src={PAYCELL_LOGO} style={{width: '160px', height: '40px', alignItems:'center'}}/>
        </Header>
        <Modal.Content>
          <div>
            <div id="divToPrint">
              <table frame="shides" rules="rows">
                <tbody>
                  <tr className={styles.tr}>
                    <td className={styles.label}>Vergi Dairesi / No</td>
                    <td className={styles.value}>{receipt.taxInfo}</td>
                  </tr>

                  <tr className={styles.tr}>
                    <td className={styles.label}>TCSN / Mersis No</td>
                    <td className={styles.value}>{receipt.tcsnMersisNo}</td>
                  </tr>

                  <tr className={styles.tr}>
                    <td className={styles.label}>Temsilcinin Ticaret Ünvanı</td>
                    <td className={styles.value}>{receipt.temsilciTicaretUnvani}</td>
                  </tr>

                  <tr className={styles.tr}>
                    <td className={styles.label}>Fatura Adresi</td>
                    <td className={styles.value}>{receipt.billAddress}</td>
                  </tr>

                  <tr className={styles.tr}>
                    <td className={styles.label}>Düzenleme Tarihi</td>
                    <td className={styles.value}>{receipt.generationDate}</td>
                  </tr>

                  <tr className={styles.tr}>
                    <td className={styles.label}>İşlem Türü</td>
                    <td className={styles.value}>{receipt.transactionType}</td>
                  </tr>

                  <tr className={styles.tr}>
                    <td className={styles.label}>İşlem Yeri</td>
                    <td className={styles.value}>PAYCELL</td>
                  </tr>

                  <tr className={styles.tr}>
                    <td className={styles.label}>BSMV Matrahı</td>
                    <td className={styles.value}>₺{receipt.bsmvMat}</td>
                  </tr>

                  <tr className={styles.tr}>
                    <td className={styles.label}>BSMV</td>
                    <td className={styles.value}>₺{receipt.bsmv}</td>
                  </tr>

                  <tr className={styles.tr}>
                    <td className={styles.label}>Referans No</td>
                    <td className={styles.value}>{receipt.transactionId}</td>
                  </tr>

                  <tr className={styles.tr}>
                    <td className={styles.label}>İşlem Tarihi</td>
                    <td className={styles.value}>{receipt.transactionDate}</td>
                  </tr>

                  <tr className={styles.tr}>
                    <td className={styles.label}>Kurum Adı</td>
                    <td className={styles.value}>{receipt.corpName}</td>
                  </tr>

                  <tr className={styles.tr}>
                    <td className={styles.label}>Abone No</td>
                    <td className={styles.value}>{receipt.subscriberNo}</td>
                  </tr>

                  <tr className={styles.tr}>
                    <td className={styles.label}>Fatura No</td>
                    <td className={styles.value}>{receipt.invoiceNo}</td>
                  </tr>
                  <tr className={styles.tr}>
                    <td className={styles.label}>Son Odeme Tarihi</td>
                    <td className={styles.value}>{receipt.invoiceDueDate}</td>
                  </tr>
                  <tr className={styles.tr}>
                    <td className={styles.label}>Kredi Kart Numarası(Maskeli)</td>
                    <td className={styles.value}>{receipt.creditCardNumber}</td>
                  </tr>
                  <tr className={styles.tr}>
                    <td className={styles.label}>Fatura Tutarı</td>
                    <td className={styles.value}>₺{receipt.paymentAmount}</td>
                  </tr>

                  <tr className={styles.tr}>
                    <td className={styles.label}>işlem Ücreti</td>
                    <td className={styles.value}>
                      ₺{receipt.commissionAmount}
                    </td>
                  </tr>
                  {receipt.donationAmount ? (
                      <tr className={styles.tr}>
                        <td className={styles.label}>Bağış Tutarı</td>
                        <td className={styles.value}>
                          ₺{receipt.donationAmount}
                        </td>
                      </tr>) : ('')
                  }
                  <tr className={styles.tr}>
                    <td className={styles.label}>Toplam Tutar</td>
                    <td className={styles.value}>
                      ₺{receipt.totalPaymentAmount}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/*<PDFViewer  height={500} showToolbar={false}>*/}
            {/*  <Receipt receiptInfo={receipt} />*/}
            {/*</PDFViewer>*/}
          </div>
        </Modal.Content>
        <Modal.Actions>
          {/*<Button onClick={printReceipt}>*/}
          {/*  <Icon name="download" /> Dekont İndir*/}
          {/*</Button>*/}

          <Button>
            <Icon name="download" />
              <PDFDownloadLink
                document={<Receipt receiptInfo={receipt} />}
                fileName='dekont'
            >
              {({ blob, url, loading, error }) =>
                  loading ? "Yükleniyor..." : "Dekont İndir"
              }
            </PDFDownloadLink>
          </Button>
          <Button onClick={() => setOpen(false)}>
            <Icon name="close" /> Kapat
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  )
}

export default ResultSuccess
